<form [formGroup]="casierForm" (ngSubmit)="submitForm()" class="flex justify-center">
  <mat-card class="center-content flex flex-col">
    <p>Casier actuel : {{ porteur.casier && porteur.casier !='' ? porteur.casier : "Non renseigné"}}</p>
    <mat-form-field>
      <mat-label>Nouveau casier</mat-label>
      <input matInput placeholder="Saisir un casier" formControlName="newCasier" />
      <mat-error *ngIf="newCasier.hasError('required')">Vous devez saisir un nouveau Casier</mat-error>
    </mat-form-field>
    <mat-card-actions class="center-actions">
      <button mat-raised-button type="submit">Enregistrer</button>
    </mat-card-actions>
  </mat-card>
</form>